/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.28",
    versionName: "0.7.0-nightly.2026.9.28",
    versionChannel: "nightly",
    buildDate: "2026-09-28T00:18:08.221Z",
    commitHash: "aa796b2ebfb2336dda2313c686979c33ad79fb6b",
};
